import { useEffect, useState } from "react";
import { Code } from "react-content-loader";
import { useTranslation } from "react-i18next";

import styled from "styled-components";

import ArticlesAPI from "../../../api/articles-api";
import { Button } from "../../ui-kit/styled-templates";
import ArticleForm from "../forms/ArticleForm";
import NiceModal from "../tools/NiceModal";

export default function AllArticlesPanel(props) {
    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const [selectedId, setSelectedId] = useState(undefined);
    const [addMode, setAddMode] = useState(false);

    useEffect(() => {
        setLoading(true);
        ArticlesAPI.getAllArticles().then((arr) => {
            setLoading(false);
            setItems(arr);
        });
    }, []);

    if (loading == true && items.length == 0) {
        return <Code />;
    }

    const selectedItem = selectedId == undefined ? undefined : items.filter((xx) => xx.id == selectedId)[0];

    return (
        <Wrapper>
            <TopPlaceholder>
                <Button
                    onClick={() => {
                        setAddMode(true);
                    }}
                >
                    {t("kr4bnbaqen")}
                </Button>
            </TopPlaceholder>

            <ItemsPlaceholder>
                {items.map((a, i) => {
                    return (
                        <Item
                            key={`${a.id}_${i}`}
                            onClick={() => {
                                setSelectedId(a.id);
                            }}
                        >
                            <ItemName>{a.name}</ItemName>
                        </Item>
                    );
                })}
            </ItemsPlaceholder>

            {selectedItem == undefined ? null : (
                <NiceModal
                    onClose={() => {
                        setSelectedId(undefined);
                    }}
                >
                    <InnerPlaceholder>
                        <ArticleForm
                            loading={loading}
                            {...selectedItem}
                            onSave={async (d) => {
                                setLoading(true);
                                await ArticlesAPI.updateArticle({ id: selectedItem?.id, ...d });
                                let arr = await ArticlesAPI.getAllArticles();
                                setItems(arr);
                                setLoading(false);
                                setSelectedId(undefined);
                            }}
                            canDelete={true}
                            onDelete={async () => {
                                setLoading(true);
                                await ArticlesAPI.deleteArticle(selectedItem?.id);
                                setSelectedId(undefined);
                                let arr = await ArticlesAPI.getAllArticles();
                                setItems(arr);
                                setLoading(false);
                            }}
                        />
                    </InnerPlaceholder>
                </NiceModal>
            )}

            {addMode == false ? null : (
                <NiceModal
                    onClose={() => {
                        setAddMode(false);
                    }}
                >
                    <InnerPlaceholder>
                        <ArticleForm
                            loading={loading}
                            onSave={async (d) => {
                                setLoading(true);
                                await ArticlesAPI.createArticle({ ...d });
                                let arr = await ArticlesAPI.getAllArticles();
                                setItems(arr);
                                setLoading(false);
                                setAddMode(false);
                            }}
                        />
                    </InnerPlaceholder>
                </NiceModal>
            )}
        </Wrapper>
    );
}

const ItemName = styled.div`
    font-weight: bold;
    font-size: 24px;
`;

const InnerPlaceholder = styled.div`
    width: 1020px;
    max-height: calc(100vh - 200px);
`;

const Wrapper = styled.div`
    width: 100%;
    box-sizing: border-box;
`;

const ItemsPlaceholder = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    box-sizing: border-box;
`;

const TopPlaceholder = styled.div`
    margin-bottom: 10px;
`;

const Item = styled.div`
    padding: 10px;
    cursor: pointer;
    background: ${(props) => (props.selected == true ? "blue" : "white")};
    color: ${(props) => (props.selected == true ? "white" : "black")};
    border-radius: 4px;
    border: 1px solid grey;
    margin: 5px;
`;
